import { useContext, useMemo } from "react"

import { CaptchaContext } from "./captcha-provider"

export function useCaptchaToken() {
  const context = useContext(CaptchaContext)

  if (!context) {
    throw new Error("useCaptchaToken must be used within a CaptchaProvider")
  }

  return useMemo(() => {
    return {
      isEnabled: context.enabled,
      captchaToken: context.token,
      getCaptchaToken: () =>
        context.enabled ? context.instance?.getResponse() : undefined,
      getCaptchaTokenAsync: () =>
        context.enabled
          ? context.instance?.getResponsePromise().catch(() => undefined)
          : undefined,
      resetCaptchaToken: () =>
        context.enabled ? context.instance?.reset() : undefined,
    }
  }, [context])
}
